/**
 * Temporary site-wide maintenance mode.
 * Set to `false` (or delete this flag usage in gatsby-browser.js / gatsby-ssr.js)
 * to restore the original website.
 */
export const MAINTENANCE_MODE = true;
